import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from "rxjs/operators";

import { NavigationRoot } from '../models/navigation-root.model';
import { Column } from "../models/column.model";

@Injectable()
export class NavigationService {
  public readonly navUrl ="api/navigation";
    constructor(public http: HttpClient) { }

    private _navData: BehaviorSubject<NavigationRoot> = new BehaviorSubject<NavigationRoot>(null);
    public navigation: Observable<NavigationRoot> = this._navData.asObservable();

    getNavigation(): Observable<NavigationRoot> {
        return this.http.get(this.navUrl).pipe(
			tap((data: NavigationRoot) => {
				for (let n = 0; n < data.panels.length; n++) {
					let panel = data.panels[n];
					let columnSet: Column[] = panel.columns;
					let reformattedColumns: Column[] = [];
					for (let c = 0; c < columnSet.length; c++) {
						let column = columnSet[c];
						//lists of items exceeding 15 in length cause the mega menu to develop scrolling behavior; we don't want that
						if (column.items != null && column.items.length > 15) { 
							let counter: number = 0;
							for (let i = 0; i < column.items.length; i++) {
								let item = column.items[i];
								if (i % 8 == 0) {
									counter = counter+= 1;
									let newColumn: Column = {
										title: `${column.title} (${counter})`,//column.title,
										uriComponent: column.uriComponent,
										items: []
									};
									reformattedColumns.push(newColumn);
								}
								reformattedColumns[reformattedColumns.length - 1].items.push(item);
							}
						} else {
							reformattedColumns.push(column);
						}
					}
					panel.columns = reformattedColumns;
				}
                this._navData.next(data);
            }));
    }

}
